import {
  getCardImage,
  getAltArts,
} from "@/lib/games/onePiece/getCardDataLocal";
import { Card, Image } from "@heroui/react";
import { AACard } from "@/models/alt-arts";
import { getTcgPlayerIdAA } from "@/lib/tcgplayer/getCardPrice";
import { usePriceManager } from "@/stores/priceManager";
import { formatPrice } from "@/lib/moneyHelper";
import { useEffect } from "react";

export default function AltArts({
  selected,
  number,
  handleClick,
}: {
  selected: AACard;
  number: string;
  handleClick: any;
}) {
  // Subscribe to prices data so component re-renders when prices load
  const prices = usePriceManager((state) => state.prices["one-piece"]);
  const fetchPrices = usePriceManager((state) => state.fetchPrices);

  // Fetch prices when component mounts
  useEffect(() => {
    fetchPrices("one-piece");
  }, [fetchPrices]);

  let displayCards = [];

  const altArts = getAltArts(number, true);
  console.log("altArts", altArts);

  for (const card of altArts) {
    if (!card.hide) {
      // TODO: remove this when updated
      if (card.set === "PRB01" && card.src === "tcgplayer") {
        continue;
      }
      let isSelected = false;
      if (selected.id === card.id && selected.src === card.src) {
        isSelected = true;
      }
      const tcgplayerId = getTcgPlayerIdAA(card);
      const price =
        tcgplayerId && prices && prices[tcgplayerId]
          ? parseFloat(prices[tcgplayerId]["l"])
          : null;

      displayCards.push(
        <div key={card.src + card.id} className="w-full">
          <Card
            className={isSelected ? "outline-3 outline-blue-500" : ""}
            isPressable
            onPress={() => handleClick(card)}
          >
            <div className="relative">
              <Image
                alt={card.name}
                src={getCardImage(card.id, "316x440", card.src)}
                width={158}
                height={220}
              />
              {price && (
                <div className="absolute bottom-1 right-1 z-20 bg-slate-800 text-sm rounded-md px-1">
                  {formatPrice(price)}
                </div>
              )}
            </div>
          </Card>
          <div className="line-clamp-3 whitespace-pre-wrap overflow-hidden text-ellipsis mt-1">
            {card.name}
          </div>
        </div>,
      );
    }
  }
  return (
    <div className="grid grid-cols-3 md:grid-cols-6 gap-2">{displayCards}</div>
  );
}

export function getAACard(
  cardNumber: string,
  src: string | undefined,
  id: string | undefined,
): AACard {
  let alts = getAltArts(cardNumber, true);
  let alt = alts.find((v) => v.id === id && v.src === src);
  if (!alt) {
    return alts[0];
  } else {
    return alt;
  }
}
